import { ApiProperty } from "@nestjs/swagger";

export class ApplicationModel{
   
    @ApiProperty()
    companyName: string;
    @ApiProperty()
    moduleName: string[];
   
}